export const GUEST_ORDER_QUERY_KEY = 'dni_guest_order'

/** WP 會員中心快速註冊的開關參數；register=1 代表開啟註冊流程，quick-register=1 代表啟用快速註冊模式 */
export const GUEST_ORDER_QUICK_REGISTER_PARAMS = {
  register: '1',
  'quick-register': '1',
} as const
